import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Auth is exclusively via httpOnly cookies set by the backend (`/api/auth/*`).
// We do NOT read or write any token in localStorage — that would expose us to XSS.
const api = axios.create({ baseURL: API, withCredentials: true });

export default api;
